module.exports = __webpack_public_path__ + "logo_sgm_events_72dpi.ffd2d1e4.png";